import React, { useReducer } from 'react';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import { generalClasses as styles } from './styles';
import StepsContext from '../../../contexts/stepsContext';
import { reducerSteps } from '../../../hooks/stepReducer';
import Steps from '../../../components/steps';
import { CLOSE_VISIT_PAGE } from '../../../libraries/texts';
import FormsRegister from './forms';

const steps = [CLOSE_VISIT_PAGE.TITLE_STEP_1, CLOSE_VISIT_PAGE.TITLE_STEP_2];

const CloseVisit = props => {
  const [step, dispatch] = useReducer(reducerSteps, { page: 0 });
  const { classes, history } = props;

  return (
    <Card className={classes.card}>
      <CardHeader title={CLOSE_VISIT_PAGE.TITLE_STEP_1} />
      <CardContent className={classes.cardContent}>
        <StepsContext.Provider
          value={{
            beforeStep: step.beforeStep,
            dispatch,
            step,
            history
          }}
        >
          <Steps steps={steps} />
          <FormsRegister />
        </StepsContext.Provider>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles)(CloseVisit);
